import { drawerAnatomy as parts } from "@chakra-ui/anatomy"
import type {
  PartsStyleFunction,
  SystemStyleFunction,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"

const baseStyleDialogContainer: SystemStyleObject = {
  h: "100%",
}

const baseStyleDialog: SystemStyleFunction = (props) => {
  const { isFullHeight } = props

  return {
    ...(isFullHeight && { height: "100%" }),
    maxH: "100%",
  }
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => ({
  dialogContainer: baseStyleDialogContainer,
  dialog: baseStyleDialog(props),
})

const sizes = {
  full: {
    dialog: { maxW: "100vw", h: "100%" },
  },
}

export const Drawer = {
  parts: parts.keys,
  baseStyle,
  sizes,
}
